import React from 'react';

export const DraggableIframeWrapper: React.FC = ({ children }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
      }}
    >
      {children}
    </div>
  );
};
